import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux/hooks';
import { transferState, listTransfer } from '../transferSlice';
import TransferSdk from "@smash-sdk/transfer/07-2022";

export const useTransfer = (): [boolean, TransferSdk.ListTransfersOutput['transfers'], string[], string?] => {
    const dispatch = useAppDispatch();
    const { list } = useAppSelector(transferState);
    useEffect(() => {
        if (!list.isLoading && !list.isSuccess) {
            dispatch(listTransfer({ hasPrevious: false }));
        }
    }, [list.isLoading, list.isSuccess, dispatch]);

    return [list.isLoading, list.transfers, list.previous, list.next]
}